import SpellName from './SpellName';

export default SpellName;
export { SpellName };
